import { render, staticRenderFns } from "./ProcessReview.vue?vue&type=template&id=703150f1"
import script from "./ProcessReview.vue?vue&type=script&lang=js"
export * from "./ProcessReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports